import React, { forwardRef } from 'react';
import Slide from '@mui/material/Slide';
import PropTypes from 'prop-types';

const SlideInDown = forwardRef((props, ref) => {
  const { in: open, children, onEnter, onExited, timeout = 400, ...other } = props;

  return (
    <Slide
      direction="down"
      in={open}
      mountOnEnter
      unmountOnExit
      onEnter={onEnter}
      onExited={onExited}
      ref={ref}
      timeout={timeout}
      {...other}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        {children}
      </div>
    </Slide>
  );
});

SlideInDown.displayName = 'SlideInDown';

SlideInDown.propTypes = {
  children: PropTypes.element,
  in: PropTypes.bool.isRequired,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
  timeout: PropTypes.number,
};

export { SlideInDown };
